import React from 'react';
import {
    Table,
    Tr,
    Td,
    Th,
    css,
    Grid,
    Header,
    Div,
} from "@bdfx/fukit"
import {clip, shadow} from "../homepage/section"
import {formatInt} from "../../common/format"
import { Bar } from 'react-chartjs-2'
import ctrans from "../../common/trans"
import Chart from "chart.js"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PricingFoxCtaButton from '../app-components/pricingfox-cta-button';
Chart.pluginService.register(ChartDataLabels);



function Competitors({competitors}) {
    const getBarData = () => ({
        labels: competitors.map(c => c.name),
        datasets: [
            {
                label: ctrans("cheaper"),
                data: competitors.map(c => c.better_price),
                backgroundColor: "#89d323",
            }, {
                label: ctrans("same"),
                data: competitors.map(c => c.same_price),
                backgroundColor: "#959393",
            }, {
                label: ctrans("more_expensive"),
                data: competitors.map(c => c.worse_price),
                backgroundColor: "#ff9d17",
            },
        ]
    })
    const getBarOptions = () => ({
        plugins: {
            datalabels: {
              display: false,
            }
          },
        legend: {
            align: "start",
            fullWidth: false,
            labels: {
                boxWidth: 15,
            },
        },        
        scales: {
            yAxes: [{
                stacked: true,
                ticks: {
                    fontStyle: "bold",
                    callback: formatInt,
                },
                scaleLabel: {
                    display: true,
                    labelString: ctrans("products_count"),
                },
            }],
            xAxes: [{
                stacked: true,
                gridLines: {
                    display: false,
                },
                ticks: {
                    fontStyle: "bold",
                    callback: function(value) {
                        if(value.length > 8) {
                            return value.substr(0, 8)+"..";//truncate
                        }
                        return value
                    },    
                },
            }]

        },
    })
    
    return (
        <Style className="section competitors npbreak">
            <div>
                <Header type={2}>
                    {ctrans("most_common_competitors")}
                </Header>
                <Grid cols="750px 400px" gap="50px">
                    <Div marginTop="-30px" width="100%" className="competitors-graph">
                        <Bar height={150} options={getBarOptions()} data={getBarData()} />
                    </Div>
                    <Div>
                        <Table header={[
                            <Th align="left">E-shop</Th>,
                            ctrans("cheaper"),
                            ctrans("same"),
                            ctrans("more_expensive"),
                        ]}>
                            {competitors.map((competitor, i) => (
                                i > 0 ?
                                <Tr key={competitor?.name+competitor?.count_sum}>
                                    <Td align="left">{competitor.name}</Td>
                                    <Td>{Math.round(competitor.better_price * 100 / competitor.count_sum)} %</Td>
                                    <Td>{Math.round(competitor.same_price * 100 / competitor.count_sum)} %</Td>
                                    <Td>{Math.round(competitor.worse_price * 100 / competitor.count_sum)} %</Td>
                                </Tr>
                                : null
                            ))}                    
                        </Table>
                    </Div>
                </Grid>

                <div style={{marginTop: "4em", marginBottom: "-4em"}}>
                    <PricingFoxCtaButton />
                </div>
        </div>

        </Style>
  );
}

const Style = css("div")({
    "@media only screen and (max-width: 1000px)": {
        ".fuk-grid": {
            display: "block",
        }
    },
    filter: shadow,
    position: "relative",
    zIndex: 10,
    "> div": {
      clipPath: clip,
      background: "#f6f6f6",
      marginTop: "-320px",
      paddingTop: "350px",
      paddingBottom: "120px",
      "> div": {
        maxWidth: "1200px",
        margin: "auto",
        },
    },
    ".fuk-header.h2": {
        marginBottom: "1.5em",
    }
})

export default Competitors;
